import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Eye } from "lucide-react";
import { toast } from "sonner";

// Platform super-admin only: view any tenant's data from one login.
export default function AccountSwitcher() {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState([]);
  const isMaster = user?.role === "master_admin";

  useEffect(() => {
    if (!isMaster) return;
    api.get("/platform/accounts").then(({ data }) => setAccounts(data)).catch(() => {});
  }, [isMaster]);

  if (!isMaster) return null;
  const current = user?.viewing_account_id || "all";

  const switchTo = async (val) => {
    try {
      await api.post("/platform/switch-account", { account_id: val === "all" ? null : val });
      toast.success(val === "all" ? "Viewing all accounts" : "Switched account view");
      window.location.reload();
    } catch (e) { toast.error(e.response?.data?.detail || "Switch failed"); }
  };

  const viewing = current !== "all";
  return (
    <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1.5" data-testid="account-switcher">
      <Eye size={14} className={viewing ? "text-amber-600" : "text-slate-400"} />
      <span className="text-xs text-slate-500 hidden sm:inline">Viewing</span>
      <Select value={current} onValueChange={switchTo}>
        <SelectTrigger data-testid="account-switcher-select" className="h-7 border-0 shadow-none text-xs font-medium w-40 focus:ring-0">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All accounts (global)</SelectItem>
          {accounts.map((a) => (
            <SelectItem key={a.id} value={a.id} data-testid={`account-switcher-opt-${a.human_id}`}>{a.name} · {a.human_id}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
